import React from "react";
import SubPageLinkCard from "./SubPageLinkCard";
import { useCurrentCampaign } from "../../../../hooks/currentCampaign";
import { Container } from "@mantine/core";
import { SegmentedContainer } from "../../../segmented-container/segmented-container";
import { useCurrentUser } from "../../../../hooks/currentUser";

const daysUntilDate = (targetDate) => {
  const currentDate = new Date();
  const target = new Date(targetDate);
  const timeDifference = target - currentDate;

  // Convert time difference from milliseconds to days
  const daysRemaining = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

  return daysRemaining;
};

const daysUntilTheEnd = daysUntilDate("August 23, 2026");

const HomePage = () => {
  const { currentUser } = useCurrentUser();
  const { campaignCode } = useCurrentCampaign();
  const subPages = [
    {
      cardId: 0,
      cardTitle: "The Arboretum",
      cardText: "Skill Tree",
      linkToPath: `/campaigns/${campaignCode}/arboretum`,
      cardImage: null,
    },
    {
      cardId: 1,
      cardTitle: "The Diviners",
      cardText: "No new messages",
      linkToPath: "",
      disabled: true,
      cardImage: null,
    },
    {
      cardId: 2,
      cardTitle: "Lore",
      cardText: "No new entries",
      linkToPath: "",
      disabled: true,
      cardImage: null,
    },
    {
      cardId: 3,
      cardTitle: "Magic Item Inventory",
      cardText: `${
        currentUser?.activeCharacter?.magicItemPoolAmount || 0
      } Available`,
      linkToPath: `/campaigns/${campaignCode}/magic-item`,
      disabled: false,
      cardImage: null,
    },
  ];

  return (
    <Container>
      <SegmentedContainer.Wrapper shadow="none" justify="center">
        <SegmentedContainer.Title>
          {daysUntilTheEnd} Days Remain
        </SegmentedContainer.Title>
        <SegmentedContainer.Segments>
          {subPages.map((sp) => (
            <SegmentedContainer.Segment
              key={`subpage-ca-${sp.cardId}`}
              span={4}
              p="sm"
            >
              <SubPageLinkCard {...sp} />
            </SegmentedContainer.Segment>
          ))}
        </SegmentedContainer.Segments>
      </SegmentedContainer.Wrapper>
    </Container>
  );
};

export default HomePage;
